// filepath: /d:/work/Bo-Tesla/frontend/src/redux/reducers/tradeReducer.js
import { createReducer } from 'redux-act';
import { fetchingTradeDataAction, updateTradeDataAction, clearTradeDataAction } from '../actions';

let trade_data = sessionStorage.getItem('trading_data');

const initialState = {
  trading_data: trade_data ? JSON.parse(trade_data) : [], // Default value
};

export default createReducer(
  {
    [fetchingTradeDataAction]: (state) => {
      return { ...state };
    },
    [updateTradeDataAction]: (state, payload) => {
      return { ...state, trading_data: payload };
    },
    [clearTradeDataAction]: (state) => {
      sessionStorage.removeItem('trading_data');
      return { ...state, trading_data: [] };
    },
  },
  initialState
);